<template>
  <fieldset class="u-module" id="anchor-price">
    <legend>{{ this.$attrs.label }}
    </legend>
    <div class="o-layout o-layout--gutter-tiny o-layout--fit">
      <div class="o-layout__cell">
        <div class="c-select">
          <label class="c-select__label" for="sortResults">
            {{ $label('from') }}
          </label>
          <select class="c-input-text c-select__element--mini" name="priceFrom" id="priceFrom" v-model="priceFrom">
            <option v-for="option in startRangeOptions" :key="option.value" :value="option.value"
              :selected="option.selected">
              €{{ option.label }}
            </option>
          </select>
          <div class="c-select__wrap-icon">
            <Icon icon="arrow-down" />
          </div>
        </div>
      </div>
      <div class="o-layout__cell">
        <div class="c-select">
          <label class="c-select__label" for="sortResults">
            {{ $label('to') }}
          </label>
          <select class="c-input-text c-select__element c-select__element--mini" name="priceTo" id="priceTo"
            v-model="priceTo">
            <option v-for="option in endRangeOptions" :key="option.value" :value="option.value"
              :selected="option.selected">
              €{{ option.label }}
            </option>
          </select>
          <div class="c-select__wrap-icon">
            <Icon icon="arrow-down" />
          </div>
        </div>
      </div>
    </div>
    <br />
    <legend class="c-filter__legend">
      <span v-if="guidingText" class="u-margin-top-tiny min-income" v-html="guidingText" />
      <ToolTip v-if="infoBoxText" :ttcontent="infoBoxText" class="c-tooltip--price"/>
    </legend>
  </fieldset>
</template>

<script>
import Icon from '@/components/Utilities/Icon.vue'
import ToolTip from '@/components/Filter/ToolTip.vue'
import { mapState } from 'vuex'

export default {
  name: 'PriceFilter',
  components: { Icon, ToolTip },
  computed: {
    ...mapState({
      selectedStartPrice: (state) => state.filter.priceFrom,
      selectedEndPrice: (state) => state.filter.priceTo,
    }),
    startRangeOptions() {
      return this.$settings('startRangeOptions').map((value) => {
        return {
          value: value,
          label: value,
          selected: value == this.selectedStartPrice,
        }
      })
    },
    endRangeOptions() {
      return this.$settings('endRangeOptions')
        .filter((value) => {
          // remove values that are greater than initial or chosen value
          if (this.selectedStartPrice >= value) {
            return false
          }
          return true
        })
        .map((value) => {
          // return objects for the <select>
          return {
            value: value > 2000 ? 9999 : value,
            label: value > 2000 ? '2000+' : value,
            selected: value == this.selectedEndPrice,
          }
        })
    },
    priceFrom: {
      get() {
        return this.selectedStartPrice
      },
      set(value) {
        // if the new value is higher or equal to the current to-price,
        // up the price-to filter to the next option
        if (value >= this.priceTo) {
          const nextPriceTo = this.$settings('endRangeOptions').find(
            (endValue) => {
              return endValue > value
            }
          )
          this.$store.dispatch('updatePriceTo', nextPriceTo)
        }
        this.$store.dispatch('updatePriceFrom', value)
        this.$store.dispatch('getUnits')
      },
    },
    priceTo: {
      get() {
        return this.selectedEndPrice
      },
      set(value) {
        this.$store.dispatch('updatePriceTo', value)
        this.$store.dispatch('getUnits')
      },
    },
    infoBoxText() {
      var infoBoxText = this.$attrs?.infoBoxText
      if (infoBoxText === '') return null

      // set min price
      var stringParts = infoBoxText.split('%minprice%')
      if (stringParts.length === 2) {
        const minPrice = this.priceTo === 9999 ? '2000+' : this.priceTo
        stringParts.splice(1, 0, minPrice)
        stringParts = stringParts.join('')
      }

      // set min income
      stringParts = stringParts.split('%income%')
      if (stringParts.length === 2) {
        const income = this.priceTo === 9999 ? '8000+' : this.priceTo * 4
        stringParts.splice(1, 0, income)
        stringParts = stringParts.join('')
      }

      return stringParts
    },
    guidingText() {
      var guidingText = this.$attrs?.guidingText
      if (guidingText === '') return null

      // set min income
      var stringParts = guidingText.split('%income%')
      if (stringParts.length === 2) {
        const income = this.priceTo === 9999 ? '8000+' : this.priceTo * 4
        stringParts.splice(1, 0, income)
        stringParts = stringParts.join('')
      }

      return stringParts
    },
  },
}
</script>

<style scoped>
.min-income {
  font-size: 0.875rem;
}
</style>
